/** Triggers a browser download for an in-memory blob under the given file name. */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const blobUrl = URL.createObjectURL(blob);

  const anchor = document.createElement('a');
  anchor.href = blobUrl;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);

  URL.revokeObjectURL(blobUrl);
};
